import React, { useEffect } from "react";

import { Grid } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useInView } from "react-intersection-observer";
import { observerConfig } from "./constants";
import { action as UIActions } from "@store/ui/reducer";

function OutletCoverImage(props) {
  const { image } = useSelector((state) => state.outlet);
  const { ref, inView } = useInView(observerConfig);
  const dispatch = useDispatch();

  useEffect(() => {
    // dispatch(UIActions.toggleStickyHeader(!inView));
  }, [inView]);
  if (!image) {
    return null;
  }

  return (
    <Grid item xs={12}>
      <div
        ref={ref}
        style={{
          width: "100%",
          height: 163,
          backgroundImage: `url(${encodeURI(image)})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
        }}
      ></div>
      {/* <img
        src={image}
        alt="outlet-cover-image"
        height={163}
        width="100%"
        ref={ref}
      /> */}
    </Grid>
  );
}
export default OutletCoverImage;
